import React from 'react';
import {Input} from 'antd';
import commonRefHOC from '../../commonRefHOC';

const { Search } = Input;
export default commonRefHOC(Search);